// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import MrstaUserService from '@services/mrsta-user'

export const getMrstaUsers = createAsyncThunk('mrstaUsers/getMrstaUsers', async (params, { rejectWithValue }) => {
  try {
    const response = await MrstaUserService.getMrstaUsers(params)
    return response
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const getMrstaUser = createAsyncThunk('mrstaUsers/getMrstaUser', async (id, { rejectWithValue }) => {
  try {
    const response = await MrstaUserService.getMrstaUser(id)
    return response
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const updateMrstaUser = createAsyncThunk('mrstaUsers/updateMrstaUser', async ({ id, userData }, { rejectWithValue }) => {
  try {
    const response = await MrstaUserService.updateMrstaUser(id, userData)
    return response
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const changeMrstaUserPassword = createAsyncThunk('mrstaUsers/changeMrstaUserPassword', async ({ id, newPin }, { rejectWithValue }) => {
  try {
    const response = await MrstaUserService.changeMrstaUserPassword(id, newPin)
    return response
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const searchMrstaUser = createAsyncThunk('mrstaUsers/searchMrstaUser', async (searchTerm, { rejectWithValue }) => {
  try {
    const response = await MrstaUserService.searchMrstaUser(searchTerm)
    return response
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const mrstaUsersSlice = createSlice({
  name: 'mrstaUsers',
  initialState: {
    data: [],
    total: 1,
    pageCount: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchResult: null,
    searchLoading: false,
    searchError: null,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMrstaUsers.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMrstaUsers.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data || action.payload.users || []
        state.total = action.payload.meta?.itemCount || action.payload.total || 0
        state.pageCount = action.payload.meta?.pageCount || 0
        state.params = action.meta.arg
      })
      .addCase(getMrstaUsers.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getMrstaUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMrstaUser.fulfilled, (state, action) => {
        state.loading = false
        state.selectedUser = action.payload.user || action.payload
      })
      .addCase(getMrstaUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(updateMrstaUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload.user || action.payload
      })
      .addCase(changeMrstaUserPassword.fulfilled, (state, action) => {
        state.selectedUser = action.payload.user || action.payload
      })
      .addCase(searchMrstaUser.pending, (state) => {
        state.searchLoading = true
        state.searchError = null
        state.searchResult = null
      })
      .addCase(searchMrstaUser.fulfilled, (state, action) => {
        state.searchLoading = false
        state.searchResult = action.payload.user || action.payload
        state.searchError = null
      })
      .addCase(searchMrstaUser.rejected, (state, action) => {
        state.searchLoading = false
        state.searchError = action.payload
        state.searchResult = null
      })
  }
})

export default mrstaUsersSlice.reducer
